export default {
  Combat: 'combat',
  NonCombat: 'noncombat',
  Rest: 'rest',
};
